module.exports = __webpack_public_path__ + "static/back-layer-ffc7a0e9e3982e3c0ac9d18e52987fe9.png";